import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center h-full gap-3">
      <h1 className="[font:var(--type-page-title)] text-[var(--ink-body)]">404 — Not Found</h1>
      <p className="[font:var(--type-body)] text-[var(--ink-secondary)]">
        The page you're looking for doesn't exist under /admin.
      </p>
      <Link to="/admin" className="[font:var(--type-label)] text-[var(--accent-primary)] hover:underline">
        Back to admin home
      </Link>
    </div>
  );
}

export function ForbiddenPage() {
  return (
    <div className="flex flex-col items-center justify-center h-full gap-3">
      <h1 className="[font:var(--type-page-title)] text-[var(--ink-body)]">403 — Forbidden</h1>
      <p className="[font:var(--type-body)] text-[var(--ink-secondary)] max-w-md text-center">
        Your role does not have access to this screen. If you believe this is a
        mistake, contact your organisation administrator.
      </p>
      <Link to="/admin/login" className="[font:var(--type-label)] text-[var(--accent-primary)] hover:underline">
        Sign in with a different account
      </Link>
    </div>
  );
}
